// Employer-requested documents on a job. Each is { name, required }:
//   required !== false → "needed to apply" (the seeker can't submit without it)
//   required === false → "needed if hired" (the seeker may apply now and bring it later)
import { isResumeDoc } from './applyDraft';

export const neededToApply = (doc) => !!doc && doc.required !== false;

// A newly added document: only a resume/CV is suggested as needed to apply — clearances,
// certificates and IDs default to "needed if hired" so they don't block applications.
export const newJobDocument = (name) => ({ name, required: isResumeDoc(name) });

export function splitJobDocuments(docs) {
  const list = Array.isArray(docs) ? docs.filter((d) => d && d.name) : [];
  return {
    toApply: list.filter(neededToApply),
    ifHired: list.filter((d) => !neededToApply(d)),
  };
}

// Same matching rule as the server's _doc_key: odd/invisible spaces collapse to one, case ignored.
// Mirrors Python's isprintable(): control/format/separator characters (zero-width and direction
// marks, soft hyphen, non-breaking space…) become one plain space; capped at 100 like the server.
const key = (s) => String(s || '').replace(/[\p{C}\p{Z}]/gu, ' ').split(/\s+/).filter(Boolean).join(' ')
  .slice(0, 100).trim().toLowerCase();

// Documents the job asks for that this applicant didn't attach.
export function missingDocuments(jobDocs, submitted) {
  const have = new Set((Array.isArray(submitted) ? submitted : []).map((d) => key(d && d.name)));
  const seen = new Set();
  return (Array.isArray(jobDocs) ? jobDocs : []).filter((d) => {
    if (!d || !d.name || have.has(key(d.name)) || seen.has(key(d.name))) return false;
    seen.add(key(d.name));
    return true;
  });
}
